import { useDispatch } from "react-redux";
import {
  authModalHandler,
  changeScreen,
  logout,
} from "../../store/slices/authSlice";
import { clearGalleryState } from "../../store/slices/gallerySlice";
import { clearProfileState } from "../../store/slices/userprofileSlice";
import { useNavigate } from "react-router-dom";

export const useAuthHandler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClickRegister = () => {
    dispatch(authModalHandler(true));
    dispatch(changeScreen("register"));
  };
  const handleClickLogin = () => {
    dispatch(authModalHandler(true));
    dispatch(changeScreen("login"));
  };
  const handleClickFP = () => {
    dispatch(changeScreen("forgotPassword"));
  };

  const handleClose = () => {
    dispatch(changeScreen(""));
  };

  const handleLogout = () => {
    localStorage.removeItem("USER_ACCESS_TOKEN");
    dispatch(clearProfileState());
    dispatch(logout());
    dispatch(clearGalleryState());
    // loggingOut();
    navigate("/");
    window.location.reload();
  };

  return {
    handleClickRegister,
    handleClickLogin,
    handleClickFP,
    handleClose,
    handleLogout,
  };
};
